export default "__VITE_ASSET__Cez6nc_K__"